import React from "react";
import { motion } from "framer-motion";
import styles from "./AuthLayout.module.css";

// Slow-drifting blurred shapes behind the brand panel.
//
// DOM + CSS filters rather than a <canvas>: App.css:43 declares
// `canvas { height: 200px !important }` app-wide, which would silently crush
// any canvas placed here (the same rule that has caught out the ECharts work).
//
// The durations are deliberately long. At 19-26s per cycle the movement is
// below the threshold where it pulls the eye off the form, which is the whole
// point of an ambient layer.
const SHAPES = [
  { key: "a", cls: styles.blobA, x: [0, 26, -12, 0], y: [0, -18, 14, 0], duration: 22 },
  { key: "b", cls: styles.blobB, x: [0, -22, 16, 0], y: [0, 20, -10, 0], duration: 26 },
  { key: "c", cls: styles.blobC, x: [0, 14, -20, 0], y: [0, -12, 18, 0], duration: 19 },
];

// `still` (reduced motion) keeps the shapes — they're part of the composition
// and the panel looks flat without them. It's the perpetual movement that gets
// dropped, not the artwork.
const AmbientField = ({ still = false }) => (
  <div className={styles.ambient} aria-hidden="true">
    {SHAPES.map((s, i) =>
      still ? (
        <div key={s.key} className={`${styles.blob} ${s.cls}`} />
      ) : (
        <motion.div
          key={s.key}
          className={`${styles.blob} ${s.cls}`}
          // Explicit: these sit under <motion.aside initial="hidden">, whose
          // hidden variant is {opacity:0, x:-16}. They declare no `variants`
          // so the label shouldn't resolve on them — but saying so removes
          // any doubt about them inheriting an opacity of 0.
          initial={false}
          animate={{ x: s.x, y: s.y }}
          transition={{
            repeat: Infinity,
            duration: s.duration,
            ease: "easeInOut",
            delay: i * 1.4, // offset the phases so they never move in lockstep
          }}
        />
      )
    )}
  </div>
);

export default AmbientField;
